var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { css } from '@patternfly/react-styles';
import { Content } from '@patternfly/react-core';
import { createUseStyles } from 'react-jss';
const useStyles = createUseStyles({
    errorStack: {
        fontFamily: 'monospace',
        fontSize: 'var(--pf-t--global--font--size--300)',
        textAlign: 'left',
        backgroundColor: 'white',
        borderStyle: 'solid',
        borderColor: 'var(--pf-t--color--gray--90)',
        overflowWrap: 'break-word',
        padding: 'var(--pf-t--global--spacer--200)'
    },
});
export const ErrorStack = (_a) => {
    var { error, className } = _a, props = __rest(_a, ["error", "className"]);
    const classes = useStyles();
    if (error.stack) {
        return (_jsx(Content, Object.assign({ className: css(classes.errorStack, className) }, props, { children: error.stack.split('\n').map((line) => (_jsx("div", { children: line }, line))) })));
    }
    if (error.name && error.message) {
        return (_jsxs(_Fragment, { children: [_jsx(Content, { component: "h6", children: error.name }), _jsx(Content, Object.assign({ className: css(classes.errorStack, className), component: "blockquote" }, props, { children: error.message }))] }));
    }
    return (_jsx(Content, { className: classes.errorStack, component: "blockquote", children: error.toString() }));
};
export default ErrorStack;
